import { Breadcrumbs as Muibreadcrumbs, Link } from '@mui/material';
import { NavigateNext, Home } from '@mui/icons-material';
import { useMatches, NavLink } from 'react-router-dom';
import { cloneElement } from 'react';

function Breadcrumbs() {
  let matches = useMatches();

  let crumbs = matches
    .filter((match) => Boolean(match.handle?.crumb))
    .map((match) => match.handle.crumb);

  return (
    <Muibreadcrumbs
      aria-label='Breadcrumb'
      sx={{
        display: 'flex',
        alignItems: 'center',
        '& .MuiBreadcrumbs-separator': { mx: '5px' },
        '& .MuiBreadcrumbs-ol': { alignItems: 'center', flexWrap: 'nowrap' },
        // Links navegáveis (itens intermediários)
        '& .MuiBreadcrumbs-li a': {
          fontFamily: "'Open Sans', sans-serif",
          fontSize: '12px',
          fontWeight: 400,
          fontStyle: 'normal',
          lineHeight: 'normal',
          color: '#3E3E3E',
          cursor: 'pointer',
          textDecoration: 'none',
          fontVariationSettings: "'wdth' 100",
          transition: 'all 0.2s ease-in-out',
          '&:hover': { color: '#333333', textDecoration: 'underline' },
          '&:focus-visible': {
            outline: '2px solid #FF3D03',
            outlineOffset: '2px',
            borderRadius: '2px',
          },
        },
        '& .MuiBreadcrumbs-li:last-of-type a': {
          fontFamily: "'Open Sans', sans-serif",
          fontSize: '12px',
          fontWeight: 700,
          fontStyle: 'normal',
          lineHeight: 'normal',
          color: '#343A40',
        },
        '& .MuiBreadcrumbs-li a.crumb-current': {
          cursor: 'default',
          textDecoration: 'none',
          pointerEvents: 'none',
          '&:hover': { color: '#343A40', textDecoration: 'none' },
        },
      }}
      separator={
        <NavigateNext
          aria-hidden='true'
          sx={{ fontSize: 16, color: '#343A40', opacity: 0.9 }}
        />
      }
    >
      <Link
        component={NavLink}
        to='/'
        aria-label='Página inicial'
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          lineHeight: 0,
          color: '#343A40',
        }}
      >
        <Home sx={{ display: 'block', fontSize: 16, color: '#343A40' }} />
      </Link>
      {!crumbs.length && (
        <Link component={NavLink} to='/'>
          Dashboard
        </Link>
      )}
      {crumbs.map((crumb, index) => {
        const isCurrent = crumbs.length === index + 1;
        return cloneElement(crumb, {
          key: index,
          underline: 'none',
          ...(isCurrent && {
            className: 'crumb-current',
            'aria-current': 'page',
            tabIndex: -1,
          }),
        });
      })}
    </Muibreadcrumbs>
  );
}
export default Breadcrumbs;
